import { Injectable, Inject  } from '@angular/core';


@Injectable()
export class LoadingOverlayService {

    constructor(@Inject('isBrowser') private isBrowser: boolean) {
    }

    showPageLoadingOverlay() {
        if(this.isBrowser)
        {
           jQuery('body').addClass('loading-overlay-showing');     
        }
    }

    hidePageLoadingOverlay() {
        if(this.isBrowser)
        {
           jQuery('body').removeClass('loading-overlay-showing');     
        }
    }    
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/loading-overlay.service.ts